import { render, staticRenderFns } from "./CustomerReturnOrders.vue?vue&type=template&id=4c8121d2&"
import script from "./CustomerReturnOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerReturnOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports